export function FullPageSpinner() {
  return (
    <div style={{ padding: 48, textAlign: 'center', color: 'var(--bk-hint)' }}>
      <div className="spinner-dot" />
      <style>{`
        .spinner-dot {
          width: 32px; height: 32px;
          border: 3px solid var(--bk-border);
          border-top-color: var(--bk-link);
          border-radius: 50%;
          margin: 0 auto;
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
